import config from '../config';
import axios from 'axios';

export function fetchPlanning(date) {
  return axios.get(`${config.api}/shifts?date=${date}&token=${config.token}`);
}



// WEBPACK FOOTER //
// ./src/api/planning.js